function updateCart($element, url) {
  const $cartForm = $element.closest('form');

  $.ajax({
    url: url ? url : '/cart/update.js',
    dataType: 'json',
    data: $cartForm.serialize(),
  })
    .done(function () {
      $.ajax({
        url: '/cart',
      })
        .done(function (response) {
          if ($('body').hasClass('template-cart')) {
            // Cart page
            location.reload();
          } else {
            const $result = $(response).find('.js-mini-cart form');
            const counter = $(response).find('.js-cart-bag').html();
            const $subtotal = $(response).find('.js-mini-cart-subtotal').html();

            $('.js-mini-cart').find('form').empty().remove();
            $('.js-mini-cart-content').append($result);

            if (counter === undefined) {
              $('.js-cart-bag').remove();
            } else {
              $('.js-cart-bag').html(counter);
            }

            $('.js-mini-cart-subtotal').empty().prepend($subtotal);

            $('body').addClass('show-mini-cart');
          }
        })
        .fail(function () {
          alert(error.responseJSON.description);
        });
    })
    .fail(function (error) {
      alert(error.responseJSON.description);
    });
}

$(document).on('click', '.js-list-count a', function (event) {
  event.preventDefault();

  const $this = $(this);
  const $qtyField = $this.closest('.js-list-count').find('.js-field');
  const min = $qtyField.attr('min');
  const max = $qtyField.attr('max');
  let fieldVal = parseInt($qtyField.val(), 10) || 0;

  if ($this.hasClass('js-minus')) {
    if (fieldVal != min) {
      fieldVal--;
    }
  } else {
    if (fieldVal < max) {
      fieldVal++;
    }
  }

  $qtyField.val(fieldVal);
});

$(document)
  .on('click', '.js-list-count a', function (event) {
    const $this = $(this);
    updateCart($this);
  })
  .on('change', '.js-list-count input', function (event) {
    const $this = $(this);
    updateCart($this);
  })
  .on('click', '.js-product-remove', function (event) {
    if (!$('body').hasClass('template-cart')) {
      event.preventDefault();

      const $this = $(this);

      updateCart($this, $this.attr('href'));
    }
  });
